import { AgentLogs } from './AgentLogs';
import { PipelineAgentLogsToggle } from './components/PipelineAgentLogsToggle';
import { useAgentLogsEnabled, useLogsViewUrlState } from './hooks';

import { PipelineLogs } from '~/scenes/Monitor/scenes/PipelineLogs/PipelineLogs';

export function MonitorLogsShell() {
  const { isEnabled } = useAgentLogsEnabled();
  const { logsView } = useLogsViewUrlState();

  if (!isEnabled) {
    return <PipelineLogs />;
  }

  return (
    <div
      className='flex flex-col overflow-auto p-10'
      data-testid='monitor-logs-shell'
    >
      <PipelineAgentLogsToggle className='mb-8' />
      {logsView === 'pipeline' ? (
        <PipelineLogs embedded />
      ) : (
        <AgentLogs embedded />
      )}
    </div>
  );
}
